// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"video_wrapper__46JNi","vimeo__play-btn":"video_vimeo__play-btn__aSSdg","vimeo__mute-btn":"video_vimeo__mute-btn___BF6U"};